import React from "react";
import SearchProjectsHeader from "./components/SearchProjectsHeader";
import ProjectsByCategory from "./components/ProjectsByCategory";
import CreateProjectButton from "./components/CreateProjectButton";

const SearchProjects = () => (
  <>
    <SearchProjectsHeader />
    <ProjectsByCategory />
    <CreateProjectButton />
  </>
);

export default SearchProjects;
